export default __webpack_public_path__ + "static/EuclidCircularB.bold-da9107f189000fddc6e7b6877df90fb4.ttf";